import { AuthPage } from "./AuthPage.tsx";

export default function LoginPage() {
  return <AuthPage mode="signin" />;
}
